import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adm, apiErr } from "../../lib/adminApi";
import { PageHead, TInput, TArea, Toggle, Btn, Card } from "../../components/admin/ui";
import ChangePasswordCard from "../../components/admin/ChangePasswordCard";
import ArtistProfileCard from "../../components/admin/ArtistProfileCard";
import NavigationCard from "../../components/admin/NavigationCard";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { adm.settings().then(setS).catch(() => {}); }, []);
  if (!s) return <p className="text-white/40 font-mono text-xs">LOADING…</p>;

  const set = (k, v) => setS((x) => ({ ...x, [k]: v }));

  const save = async () => {
    try {
      const { _id, id, updatedAt, membershipPlans, memberDiscountPercent, allowDiscountStacking, referral, ...body } = s;
      await adm.saveSettings(body);
      toast.success("Settings saved.");
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="admin-settings">
      <PageHead title="Site Settings" sub="Global site configuration. Membership pricing lives under Inner Circle.">
        <Btn onClick={save} testid="settings-save">SAVE</Btn>
      </PageHead>

      <ChangePasswordCard />

      <ArtistProfileCard s={s} set={set} />

      <NavigationCard s={s} set={set} />

      <Card className="mt-6 grid md:grid-cols-2 gap-4">
        <TInput label="FOOTER COPY" value={s.footerCopy} onChange={(v) => set("footerCopy", v)} testid="settings-footer" />
        <TInput label="CONTACT EMAIL" value={s.contactEmail} onChange={(v) => set("contactEmail", v)} />
        <TInput label="DEFAULT SEO TITLE" value={s.seoTitle} onChange={(v) => set("seoTitle", v)} />
        <TArea label="DEFAULT SEO DESCRIPTION" value={s.seoDescription} onChange={(v) => set("seoDescription", v)} rows={2} />
      </Card>

      <Card className="mt-6 grid md:grid-cols-2 gap-6">
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-3">GLOBAL ANNOUNCEMENT</p>
          <Toggle label="ENABLED" checked={!!s.announcement?.enabled} onChange={(v) => set("announcement", { ...(s.announcement || {}), enabled: v })} testid="announcement-toggle" />
          <div className="mt-3"><TInput label="TEXT" value={s.announcement?.text} onChange={(v) => set("announcement", { ...(s.announcement || {}), text: v })} testid="announcement-text" /></div>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] text-gold mb-3">MAINTENANCE STATE</p>
          <Toggle label="ENABLED" checked={!!s.maintenance?.enabled} onChange={(v) => set("maintenance", { ...(s.maintenance || {}), enabled: v })} />
          <div className="mt-3"><TInput label="MESSAGE" value={s.maintenance?.message} onChange={(v) => set("maintenance", { ...(s.maintenance || {}), message: v })} /></div>
        </div>
      </Card>
    </div>
  );
}
